export enum StepProps {
	ReviewAndSubmit_RuleName = "review-and-submit/rule-name",
	ReviewAndSubmit_ExcludedZones = "review-and-submit/excluded-zones",
	ReviewAndSubmit_RuleId = "review-and-submit/rule-id",
	DefineDuty_InspectionTypes = "define-duty/inspection-types",
	DefineDuty_StartCondition = "define-duty/start-condition",
	DefineDuty_WorkPeriods = "define-duty/work-periods",
	DefineDuty_Frequency = "define-duty/frequency",
	DefineDuty_Timezone = "define-duty/timezone",
	DefineDuty_ExpireMinutes = "define-duty/expire-minutes",
	DefineDuty_Zones = "define-duty/zones",
	Common_Config = "common/config",
	Common_Zones = "common/zones",
	Common_CompanyId = "common/companyid",
	Common_InspectionTypes = "common/inspection-types",
	Common_Original_RuleName = "common/original-rule-name",
	Common_Original_Data = "common/original-data",
}
